/**
 * CalculatorRedirectPage — редиректит на /calculator/:code
 * где code = последний выбранный ЦОД из стора.
 * Если ЦОД неизвестен — показывает выбор.
 */
import { Navigate, useParams } from 'react-router-dom'

export default function CalculatorRedirectPage() {
  const { dcCode } = useParams<{ dcCode: string }>()
  if (!dcCode) {
    return <Navigate to="/" replace />
  }
  return <Navigate to={`/${dcCode}/calculator/${dcCode}`} replace />
}
